var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28,
    fill: "#FFF9DD",
    stroke: "#FFE673",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9762 27.4053C29.598 28.5255 28.5938 29.2061 27.4892 29.2061C27.3124 29.2061 27.1389 29.1645 26.9651 29.129L28.3068 31.1416C28.5645 31.5281 28.4602 32.0493 28.0737 32.3071C27.6809 32.5674 27.1617 32.4549 26.9081 32.074L25.0859 29.3407V39.1722H41.1674C42.5578 39.1722 43.6889 38.0411 43.6889 36.6507V27.4053H29.9762ZM39.4864 35.8102H32.6504C32.1858 35.8102 31.8099 35.4343 31.8099 34.9697C31.8099 34.5052 32.1858 34.1292 32.6504 34.1292H39.4864C39.951 34.1292 40.3269 34.5052 40.3269 34.9697C40.3269 35.4343 39.951 35.8102 39.4864 35.8102ZM39.4864 32.4482H32.6504C32.1858 32.4482 31.8099 32.0723 31.8099 31.6077C31.8099 31.1432 32.1858 30.7673 32.6504 30.7673H39.4864C39.951 30.7673 40.3269 31.1432 40.3269 31.6077C40.3269 32.0723 39.951 32.4482 39.4864 32.4482Z",
    fill: "url(#paint0_linear_1351_3016)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9553 25.7659L25.7578 26.5645L26.9553 27.3631C27.5929 27.7881 28.4451 27.3315 28.4451 26.5653C28.4451 25.7957 27.5904 25.3425 26.9553 25.7659Z",
    fill: "url(#paint1_linear_1351_3016)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5215 19C16.1311 19 15 20.1311 15 21.5215V25.724H18.5147C19.0832 24.04 21.0388 23.4172 22.4651 24.3672L23.4049 24.9938V19H17.5215Z",
    fill: "url(#paint2_linear_1351_3016)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1674 19H25.0859V24.9938L26.0257 24.3672C27.437 23.4244 29.4041 24.0276 29.9765 25.724H43.6889V21.5215C43.6889 20.1311 42.5578 19 41.1674 19Z",
    fill: "url(#paint3_linear_1351_3016)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5366 25.7663C20.8981 25.3406 20.0469 25.8 20.0469 26.5641C20.0469 27.3305 20.896 27.7899 21.5366 27.3636L22.7342 26.5649L21.5366 25.7663Z",
    fill: "url(#paint4_linear_1351_3016)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5828 32.074C21.325 32.4589 20.8038 32.5615 20.4172 32.3071C20.0306 32.0493 19.9264 31.5282 20.1841 31.1416L21.5258 29.129C21.352 29.1645 21.1785 29.2061 21.0016 29.2061C19.8944 29.2061 18.8914 28.5228 18.5143 27.4053H15V36.6508C15 38.0412 16.1311 39.1723 17.5215 39.1723H23.4049V29.3408L21.5828 32.074Z",
    fill: "url(#paint5_linear_1351_3016)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1351_3016",
    x1: 29.3901,
    y1: 34.0582,
    x2: 43.5552,
    y2: 34.0528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1351_3016",
    x1: 26.3796,
    y1: 26.6904,
    x2: 28.4258,
    y2: 26.6897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1351_3016",
    x1: 16.9446,
    y1: 22.8017,
    x2: 23.3445,
    y2: 22.7997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1351_3016",
    x1: 29.3901,
    y1: 22.8017,
    x2: 43.5552,
    y2: 22.7923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1351_3016",
    x1: 20.6686,
    y1: 26.6909,
    x2: 22.7148,
    y2: 26.6902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1351_3016",
    x1: 16.9446,
    y1: 34.0582,
    x2: 23.3445,
    y2: 34.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcCard);
export default __webpack_public_path__ + "static/media/GC Card.a6d6b3869127419abe01093ef2a5ef2b.svg";
export { ForwardRef as ReactComponent };